export const ENV_MODE = import.meta.env.VITE_ENV || import.meta.env.MODE;
export const CUSTOMER_BASE_URL = import.meta.env.VITE_CUSTOMER_BASE_URL;
export const INSTITUTE_BASE_URL = import.meta.env.VITE_INSTITUTE_BASE_URL;
export const LANDING_BASE_URL = import.meta.env.VITE_LANDING_BASE_URL;
export const LANDING_API_BASE_URL = import.meta.env.VITE_LANDING_API_BASE_URL;
export const INSURANCE_BASE_URL = import.meta.env.VITE_INSURANCE_BASE_URL;
export const CMS_API_BASE_URL = import.meta.env.VITE_CMS_API_BASE_URL;
export const ERP_SDK_SCRIPT_URL = import.meta.env.VITE_ERP_SDK_SCRIPT_URL;
export const ERP_SDK_ENV = import.meta.env.VITE_ERP_SDK_ENV;
export const GQ_API_KEY = import.meta.env.VITE_GQ_API_KEY;
export const OLD_WEBSITE = import.meta.env.VITE_OLD_WEBSITE;
